export default "__VITE_ASSET__V_HlUn6v__"